import Section from './SliderImageBlock'
import isEmpty from './SliderImageIsEmpty'

export default { isEmpty, Section }
